import React from 'react';

interface MobileFrameProps {
  children: React.ReactNode;
  time?: string;
}

const MobileFrame: React.FC<MobileFrameProps> = ({ children, time = '09:41' }) => {
  return (
    <div
      style={{
        width: '220px',
        aspectRatio: '9 / 18',
        background: '#0A1929',
        borderRadius: '28px',
        padding: '8px',
        boxShadow: '0 25px 70px -20px rgba(26,111,168,.35), inset 0 0 0 2px rgba(255,255,255,.04)',
        position: 'relative',
        margin: '0 auto',
      }}
    >
      {/* Screen */}
      <div
        style={{
          width: '100%',
          height: '100%',
          background: 'var(--white)',
          borderRadius: '22px',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        {/* Notch */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: '70px',
            height: '18px',
            background: '#0A1929',
            borderBottomLeftRadius: '10px',
            borderBottomRightRadius: '10px',
            zIndex: 3,
          }}
        />

        {/* Status bar */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '6px 18px 4px',
            fontFamily: "'Montserrat', sans-serif",
            fontSize: '.55rem',
            fontWeight: 600,
            color: 'var(--ink)',
          }}
        >
          <span>{time}</span>
          <div style={{ display: 'flex', gap: '3px', alignItems: 'center' }}>
            <svg width="10" height="6" viewBox="0 0 14 10" fill="currentColor">
              <rect x="0" y="6" width="2" height="4" rx=".5" />
              <rect x="4" y="4" width="2" height="6" rx=".5" />
              <rect x="8" y="2" width="2" height="8" rx=".5" />
              <rect x="12" y="0" width="2" height="10" rx=".5" />
            </svg>
            <svg width="14" height="7" viewBox="0 0 22 10" fill="none" stroke="currentColor">
              <rect x="1" y="1" width="18" height="8" rx="2" strokeWidth="1" />
              <rect x="2" y="2" width="14" height="6" rx="1" fill="currentColor" />
            </svg>
          </div>
        </div>

        {/* Content */}
        <div style={{ padding: '0 12px', height: 'calc(100% - 28px)', overflow: 'hidden' }}>{children}</div>
      </div>
    </div>
  );
};

export default MobileFrame;
